import { Component, OnInit } from '@angular/core';
import { Gallery } from 'src/app/model/gallery';
import { GalleryService } from 'src/app/services/gallery.service';

@Component({
  selector: 'gallery-overview-list',
  templateUrl: 'gallery-overview-list.html'
})

export class GalleryOverviewListComponent implements OnInit {
  private galleries: Gallery[] = [];

  constructor(private readonly galleryService: GalleryService) { }

  ngOnInit(): void {
    this.galleryService.getGalleries().subscribe(galleries => this.galleries = galleries.filter(gallery => gallery.show));
  }
}